export default __webpack_public_path__ + "static/media/Lockheed_Martin.01de0cfa.png";